import React from 'react';
import ReactDOM from 'react-dom/client';
import { initGA } from '@ari/analytics';
import App from './App';

initGA();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
